import classNames from "classnames";
import { ErrorNote } from "../../../forms/improved_components/error_note";
import SignInWithGoogleButton from "./sign_in_with_google_button";

export default function LinkAccount(props: {
	authUrl: string;
	errorMessage?: string;
	missingScopes?: string[];
}) {
	return (
		<div className="flex flex-col gap-4">
			{props.errorMessage && (
				<ErrorNote
					error={
						<>
							{props.errorMessage && (
								<p className="text-warning">
									{props.errorMessage}
								</p>
							)}
							{props.missingScopes &&
								props.missingScopes.length > 0 && (
									<ul className="list-disc list-inside">
										{props.missingScopes.map((scope) => (
											<li>
												{scope.replace(
													"https://www.googleapis.com/auth/",
													""
												)}
											</li>
										))}
									</ul>
								)}
						</>
					}
				></ErrorNote>
			)}

			<div className="note flex flex-col gap-3">
				<p className="has-text-centered">
					Link your Google account to allow{" "}
					<span className="sesh-text">sesh</span> to sync with Google
					Calendar
				</p>
				<SignInWithGoogleButton href={props.authUrl} />
			</div>
		</div>
	);
}
